import { createContext } from "react";

export type LoadingContext = {
	startLoading: () => void;
	stopLoading: () => void;
};

export const LoadingContext = createContext<LoadingContext | null>(null);
